<template>
  <v-col cols="12" :class="{ 'grey--text text--darken-1': ! active }">
    <v-icon
      left
      small
      :color="active ? 'grey darken-3' : 'grey'"
      v-text="icons[icon]"
    />
    <slot />
  </v-col>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      icon: {
        required: true,
        type: String,
      },
      active: {
        required: true,
        type: Boolean,
      },
    },
  }
</script>
